import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";
import { PrimaryButton } from "components/Button/style";
import { Col } from "react-bootstrap";
import { FaQuestionCircle } from "react-icons/fa";

export const Container = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ButtonHeaderContainer = styled.span`
  width: 700px;
  background-color: red;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding: 0;
  margin: 0;
`;

export const FormContainer = styled.div`
  margin-top: 2rem;

  select {
    border-radius: 8px;
    height: 38px;
  }

  .row {
    height: 125px;
  }
`;

export const RadioContainer = styled.div`
  padding-top: 10px;
`;

export const OptionContainer = styled.span`
  margin-right: 24px;

  input {
    accent-color: ${({ theme }) => theme.colors.project.main};
    margin-right: 1rem;
    width: 1rem;
    height: 1rem;
  }
`;

export const IconeTooltipServico = styled(FaQuestionCircle)`
  color: ${({ theme }) => theme.colors.project.main};
  margin-left: 10px;
`;

export const InputContainer = styled.div`
  margin-top: 24px;
`;
